import axios from 'axios';
import BaseApi from '../BaseApi';
import {
	TransitionActionTaskBaseModel,
	TransitionCompleteResponse,
} from 'src/Types/Task';

export default class SimpleTaskAPI extends BaseApi {
	static gotoTransaction = async (
		data: TransitionActionTaskBaseModel,
	): Promise<TransitionCompleteResponse> => {
		const url = window.host + '/SimpleTask/GoToTransition';
		try {
			const request = await axios.post(url, data, {
				withCredentials: true,
			});
			if (this.checkUnauthorized(request)) {
				throw new Error(`Ошибка SimpleTask/GoToTransition !`);
			} else {
				return request.data;
			}
		} catch (error: any) {
			throw new Error(`Ошибка SimpleTask/GoToTransition!`);
		}
	};
}
